<template lang="pug">
BriqPanel
  h2.mb-S Deals
  table(class="table table-striped product-deals-table")
    thead
      tr
        th Deal
        th Price
        th Available to customer
    tbody
      DealRow(v-for="deal in deals" :deal="deal" :key="deal.Key" :priceFormatter="priceFormatter")
      tr(v-if="deals.length === 0")
        td(colspan="3") Not used by any deals
</template>

<script>
import DealRow from './DealRow.vue'

export default {
  name: 'DealsTable',
  components: { DealRow },
  props: {
    deals: Array,
    priceFormatter: {
      type: Intl.NumberFormat,
      required: true,
    },
  },
}
</script>

<style lang="stylus" scoped>
.product-deals-table
  width 100%

.table-striped > tbody > tr
  &:nth-of-type(odd)
    background #f1f3f6

  &[data-toggle]:hover, &[data-href]:hover, &.active
    background #EAEAEA

.table
  td
    padding 8px 12px

  th
    min-width 90px
</style>
